import { Link } from 'react-router-dom'
import { useI18n } from '@/lib/i18n'
import ThemeSwitcher from '@/components/ui/ThemeSwitcher/ThemeSwitcher'
import LanguageSwitcher from '@/components/ui/LanguageSwitcher/LanguageSwitcher'
import Wordmark from '@/components/ui/Wordmark'
import company from '@/content/company.json'
import './Footer.css'

export default function Footer() {
  const { t, to } = useI18n()
  const year = new Date().getFullYear()

  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <Wordmark as="span" size={40} />
            <p className="footer__motto">{t('brand.motto')}</p>
          </div>

          <nav className="footer__col" aria-label="Footer">
            <span className="eyebrow eyebrow--plain">Softmaze</span>
            <ul role="list">
              <li>
                <Link to={to('/')}>{t('nav.home')}</Link>
              </li>
              <li>
                <Link to={to('/projects')}>{t('nav.projects')}</Link>
              </li>
              <li>
                <Link to={to('/services')}>{t('nav.about')}</Link>
              </li>
              <li>
                <Link to={to('/faq')}>{t('nav.faq')}</Link>
              </li>
              <li>
                <Link to={to('/contact')}>{t('nav.contact')}</Link>
              </li>
              <li>
                <Link to={to('/archive')}>{t('nav.archive')}</Link>
              </li>
              <li>
                <Link to={to('/nisg-2026')}>{t('nav.nisg')}</Link>
              </li>
            </ul>
          </nav>

          <div className="footer__col">
            <span className="eyebrow eyebrow--plain">{t('nav.contact')}</span>
            <ul role="list">
              <li>
                <a href={`mailto:${company.mail}`}>{company.mail}</a>
              </li>
              <li>
                <a href={company.whatsapp} target="_blank" rel="noopener noreferrer" className="wa-text">
                  WhatsApp
                </a>
              </li>
              <li className="muted">{company.address}</li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <span className="mono muted" suppressHydrationWarning>
            © {year} SoftMaze Solutions GmbH · {t('nav.madeIn')}
          </span>
          <div className="footer__controls">
            <Link to={to('/imprint')} className="mono">
              {t('nav.imprint')}
            </Link>
            <Link to={to('/privacy')} className="mono">
              {t('nav.privacy')}
            </Link>
            <LanguageSwitcher />
            <ThemeSwitcher />
          </div>
        </div>
      </div>
    </footer>
  )
}
